import { render, staticRenderFns } from "./ProtocolCourse.vue?vue&type=template&id=4d790aba&"
import script from "./ProtocolCourse.vue?vue&type=script&lang=js&"
export * from "./ProtocolCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports